var components;
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_c('v-uni-view',[_vm._v("人教点读 1-9年级正版教材点读")]),_c('v-uni-view',[_vm._v("Copyright ©2015-"+_vm._s(_vm.currentYear)+" 人教点读")]),_c('a',{attrs:{"href":"https://beian.miit.gov.cn/","target":"_blank"}},[_vm._v("京ICP备11048806号")])],1)}
var recyclableRender = false
var staticRenderFns = []

export { render, staticRenderFns, recyclableRender, components }